<!-- 录播 -->
<template>
  <div class="playBack">
    <div :class="['video-record-page', isFullScreen ? 'is-full-screen' : '']">
      <div :class="['video-record', fileVideo ? 'file-video-record' : '']">
        <div id="playbackPlayer" v-show="!fileVideo || iconStatus" :class="!iconStatus ? 'fullPlaybackPlayer' : ''"
          ref="playbackPlayer" @touchstart="touchstartHandle('playbackPlayer', $event)"
          @touchmove="touchmoveHandle('playbackPlayer', $event)"></div>
        <div v-if="jurisdiction" class="jurisdiction">没有此课程权限</div>
        <template v-if="fileVideo">
          <div id="playbackPanel" :class="!iconStatus ? 'fullPlaybackPanel' : ''"></div>
        </template>
        <div class="video-control">
          <!-- <template v-if="controlShow"> -->
          <template v-if="controlShow">
            <div class="control-top">
              <img src="../../assets/img/live/back.png" @click="goBack" alt="" class="control-icon" />
              <span class="live-title">{{ headerTitle }}</span>
              <img
                @click="evaluateVisible = true"
                class="zan"
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/zan.png"
                alt=""
              />
            </div>
            <div class="control-bottom">
              <div class="slider" v-show="!isFullScreen">
                <van-slider v-model="sliderValue" @change="onChange" button-size="16" active-color="#FF6C02"
                  inactive-color="#ebedf0" />
              </div>
              <div class="control-bottom-bottom">
                <div class="control-bottom-left">
                  <div @click="playPause">
                    <template v-if="videoPlaying">
                      <img src="../../assets/img/live/end.png" alt="" class="control-icon" />
                    </template>
                    <template v-else>
                      <img src="../../assets/img/live/start.png" alt="" class="control-icon" />
                    </template>
                  </div>
                  <div v-if="currentDuration">{{ currentDuration }} / {{ totalDuration }}</div>
                </div>
                <div class="control-bottom-right">
                  <span @click="switchSpeed">{{ speed[currentSpeedIndex] }}</span>
                  <img @click="fullScreenClick" :src="isFullScreen ? narrow : enlarge" alt="" />
                  <img v-if="isFullScreen" @click="iconStatus = !iconStatus" :src="!iconStatus ? putAway : open"
                    alt="control-icon" />
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="speedLlst" v-if="isFullScreen && speedShow">
          <p v-for="(item, index) in speed" :key="index" :class="[index === currentSpeedIndex ? 'active' : '']">
            {{ item }}
          </p>
        </div>
      </div>
      <!--聊天，课程推荐,广告 -->
      <div v-show="!isFullScreen || iconStatus" :class="[
      'live-content',
      fileVideo ? 'file-live-content' : '',
      isAndroid && isFullScreen ? 'android-live-content' : '',
    ]">
        <div class="teacherList" v-if="isFullScreen && !fileVideo">
          <span v-for="(item, index) in RecommendCourse.teacherList" :key="index">
            {{ item.name }}{{ index != RecommendCourse.teacherList.length - 1 ? '、' : '' }}
          </span>
        </div>
        <div class="live-content-box">
          <ul class="live-content-tab">
            <li @click="changeTab(index)" v-for="(item, index) in tablist"
              v-show="isFullScreen ? index === 0 : index >= 0" :key="index">
              {{ cardSelected !== 0 && index === 0 ? '老师' : item }}
              <img v-if="index === 0" class="icon" :src="showTabCard ? UPICON : DOWNICON" alt="" />
              <span v-if="selected === index && !isFullScreen" class="border"></span>
            </li>
            <li v-show="!isFullScreen">
              <JoinGroup v-if="buyInfo.productId" :buyInfo="{ ...buyInfo }" />
            </li>
          </ul>
          <ul class="tab-card" v-show="showTabCard">
            <li v-for="(item, index) in tabCardList" :key="index" :class="{ active: cardSelected === index }"
              @click="changeList(index)">
              <span>{{ item }}</span>
              <img v-show="cardSelected === index" class="icon" :src="CHECKEDICON" alt="" />
            </li>
          </ul>
          <div :class="[
      'tab-content',
      !isFullScreen && RecommendCourse.imagesH5 ? 'tab-content-padding' : '',
    ]">
            <Advertising v-if="!isFullScreen" :RecommendCourse="RecommendCourse" :filePlayer="true" />
            <Chat v-show="selected === 0" :isCommentGroup="isCommentGroup" :selected="cardSelected"
              :skuId="buyInfo.skuId" :chatList="chatList" :currentTimeStamp="currentTimeStamp"
              :isFullScreen="isFullScreen" />
          </div>
        </div>
      </div>
      <div class="speedPopup" v-if="speedPopup" @click="speedPopup = false">
        <div>
          <p v-for="(item, index) in speed" :key="index" :class="index === currentSpeedIndex ? 'active' : ''"
            @click="switchSpeedPopup(index)">
            {{ item }}
          </p>
        </div>
      </div>
    </div>
    <!-- 横屏时使用 -->
    <div class="fullSlider" v-show="isFullScreen && controlShow">
      <van-slider vertical v-model="sliderValue" @change="onChange" button-size="16" active-color="#FF6C02"
        inactive-color="#ebedf0" />
    </div>
    <OpenApp v-if="!isFullScreen" ref="openApp" />
    <CommonLoading :loading="loading" />
    <Foot v-if="!isFullScreen" />
    <Evaluate
      ref="evaluate"
      v-if="routeParams"
      :visible="evaluateVisible"
      @evaluateClose="evaluateClose"
      :resourceId="routeParams.resourceId"
      :resourceType="1"
      :resourceName="headerTitle"
      :productId='productId'
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { Slider } from 'vant';
import { mapState } from 'vuex';
import moment from 'moment';
import loadJS from 'load-js';
import { LIVE_SITE_ID } from '@/utils/common';
import OpenApp from '@/pages/live/components/openApp.vue';
import { reqGetPlayBack, sendUploadStudyProgress, reqliveDetails, liveBroadcast } from '@/api/live';
import { reqGetNodeResource, reqGetCheckCourse } from '@/api/learn';
import { reqCourseDetail, reqNewLearnProgress } from '@/api/learningGuidePage';
import { reqClassNameType } from '@/api/courseDetail';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import Foot from '@/components/foot/privacy.vue';
import Advertising from '../live/components/advertising.vue';
import Chat from './components/chat.vue';
import { timerCount, gioPlatform, resetCoursePackage } from '../../utils/tools';
import { reqIsBuyProduct } from '../../api/courseDetail/index';
import JoinGroup from '../live/components/joinGroup.vue';
import Evaluate from '@/pages/video/components/evaluate.vue';
import { judgmentPlatform } from '@/utils/tools';

let flag = false;
let startViewTime = 0;

Vue.use(Slider);

export default {
  data() {
    return {
      tablist: ['讨论区'],
      tabCardList: ['全部讨论', '仅看老师'],
      cardSelected: 0,
      selected: 0,
      showTabCard: false,
      DOWNICON: require('../../assets/img/live/down.png'),
      UPICON: require('../../assets/img/live/up.png'),
      CHECKEDICON: require('../../assets/img/live/checked.png'),
      routeParams: null,
      isFullScreen: false, // 是否全屏
      timer: null, // 300秒定时器
      lastLearnDuration: 0, // 上次学习进度
      recordVideoId: 0,
      recordId: 0,
      isFirstEnter: true,
      videoEndTool: false,
      headerTitle: '视频播放',
      loading: true,
      reportCount: 0,
      fileVideo: true, // true 三分屏模式  false  大视频模式
      controlShow: true,
      chatList: [], // 所有的聊天记录
      coordinate: {
        // 坐标
        client: {},
        elePosition: {},
      },
      videoPlaying: false,
      sliderValue: 0, // 进度条进度
      sliderTimer: null, // 进度条实时获取
      totalDuration: '00:00', // 总时长
      currentDuration: '', // 当前时间
      currentTimeStamp: 0, // 当前时间戳  用于聊天记录
      speed: ['0.8X', '1.0X', '1.2X', '1.5X', '2.0X'], // 视频倍速列表
      speedPopup: false, // 横屏时选进度条弹窗
      currentSpeedIndex: 1, // 当前倍速
      speedShow: false, // true 显示倍速 false 不显示倍速
      enlarge: require('../../assets/img/live/full_screen.png'),
      narrow: require('../../assets/img/live/narrow.png'),
      putAway: require('../../assets/img/live/putAway.png'),
      open: require('../../assets/img/live/open.png'),
      iconStatus: true,
      RecommendCourse: {}, // 推荐数据
      controlTimer: null, // 控制条显隐
      isAndroid: navigator.userAgent.match(/android/i), // 处理在安卓机上的兼容问题(全屏时可点击 但不显示)
      firstReportClock: null,
      jurisdiction: false, // 视频观看权限
      canPlay: true,
      buyInfo: {}, // 开课信息
      isCommentGroup: 0, // 直播间是否开启分组
      evaluateVisible: false,
      isAllowAudition:null   //0 不是 1是
    };
  },

  components: {
    OpenApp,
    CommonLoading,
    Foot,
    Advertising,
    Chat,
    JoinGroup,
    Evaluate,
  },

  computed: {
    ...mapState(['userInfo']),
  },

  watch: {
    evaluateVisible(data) {
      const myVideo = document.getElementById('playbackVideo');
      if (!myVideo.paused && data) {
        myVideo.pause();
        this.videoPlaying = false;
      } else {
        myVideo.play();
        this.videoPlaying = true;
      }
    },
  },
  beforeDestroy() {
    if (!this.$root.$data.isApp) {
      this.uploadPageWxpose();
    }
  },
  created() {},
  mounted() {
    this.initData();
    if (!this.$root.$data.isApp) {
      window.addEventListener('beforeunload', this.uploadPageWxpose);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        document.getElementById('playbackVideo').pause();
      }
    });
  },

  methods: {
    uploadPageWxpose() {
      if (flag && startViewTime) return;
      flag = true;
      const endViewTime = moment().unix();
      const diff = endViewTime - startViewTime;
      startViewTime = 0;
      const { productId, productName, productCategoryName, price,isAllowAudition } = this;
      if (price !== null && price !== undefined) {
        gio('track', 'videoDetailexit_event', {
          courseId_var: productId.toString(),
          courseName_var: productName,
          courseSubject_var: productCategoryName,
          coursePrice_var: price.toString(),
          isLogin_var: 'true',
          platform_var: gioPlatform(),
          browsingDuration_var: `${diff >= 600 ? 600 : diff}`,
          isAudition_var: isAllowAudition ? '是' : '否',
        });
      }

    },
    initData() {
      // 初始化数据
      this.loading = true;
      this.isFirstEnter = true;
      this.lastLearnDuration = 0;
      this.routeParams = this.$route.params;
      this.destroyPlay();
      window.clearInterval(this.timer);
      this.init();
    },
    // 查询开课信息
    async getBuyInfo() {
      const res = await reqIsBuyProduct(this.routeParams.courseId);
      if (res?.code === 0 && res?.data?.length) {
        this.buyInfo = res?.data?.[0];
      }
    },
    async init() {
      await this.getCourseTreeInfo(); // 获取课程详情
      if (!this.canPlay) return;
      const result = await this.checkCourse(); // 播放权限
      if (!result) {
        return;
      }
      await this.getBuyInfo(); // 购买信息
      await this.getLearnDuration(); // 获取上次播放记录
      await this.getNodeResource(); // 遍历tree选中当前节点
      loadJS([
        {
          async: false,
          url: 'https://view.csslcloud.net/js/sdk/3.7.4/playbackSDK.js',
        },
      ]).then(() => {
        // 获取回放信息
        this.getPlayBackInfo();
        this.getCourseIds();
        this.gioReName();
      });
    },

    // 点击返回至导学页
    goBack() {
      if (this.isFullScreen) {
        this.fullScreenClick();
      } else {
        // this.$router.go(-1);
        this.$router.replace({
          path: '/learningGuide',
          query: {
            catalogId: this.routeParams.openCourseId,
          },
        });
      }
    },

    // 当前视频的标题名
    async getNodeResource() {
      const params = {
        nodeId: this.routeParams.chapterId,
      };
      const res = await reqGetNodeResource(params);
      if (res.code === 0) {
        document.title = this.headerTitle;
        this.headerTitle = res.data[0].resourceName;
        this.isAllowAudition = res.data[0].isAllowAudition;
        document.title = this.headerTitle;
      }
    },

    // 鉴权
    async checkCourse() {
      let result = false;
      try {
        const res = await reqGetCheckCourse({
          curriculumId: this.productCurriculumId || '',
          nodeId: this.routeParams.chapterId,
          resourceId: this.routeParams.resourceId,
          resourceType: 2,
        });
        if (res.code === 0 && res.data === true) {
          result = true;
        } else {
          this.$toast('您暂无权限观看此视频～');
        }
      } catch (e) {
        console.log('鉴权失败');
      }
      return result;
    },

    // 获取课程目录信息
    async getCourseTreeInfo() {
      try {
        const result = await reqCourseDetail({
          id: this.routeParams.openCourseId,
        });
        if (result.code === 0) {
          //console.log('课程目录信息', result);
          const { productCurriculumId, productId, productName, productCategoryName, productSkuBaseInfoRespVO: { price } } = result.data;
          Object.assign(this, {
            productCurriculumId,
            productId,
            productName,
          });
          this.productCategoryName = productCategoryName;
          this.price = price;
        } else {
          this.$toast(result.msg);
          this.canPlay = false;
        }
      } catch (e) {
        this.loading = false;
        if (String(e).indexOf('Network Error') > -1) {
          this.$toast('无可用网络，请检查您的网络');
        } else {
          this.$toast('获取课程详情失败');
        }
      }
    },
    // 根据直播间id查询推荐的课程id  res?.data?.productList?.split(',');
    async getCourseIds() {
      const res = await reqliveDetails(Number(this.routeParams.resourceId));
      if (res?.code === 0) {
        this.RecommendCourse = res?.data;
      }
    },
    // 获取回放信息
    async getPlayBackInfo() {
      try {
        const res = await reqGetPlayBack({ liveId: this.routeParams.resourceId });
        if (res) {
          //console.log('回放信息',res)
          const { ccId, id } = res.data;
          this.recordId = ccId;
          this.recordVideoId = id;
          flag = false;
          startViewTime = moment().unix();
        }
        this.setPlayerCallBackLive();
      } catch {
        this.$toast('获取回放信息出错');
      }
    },

    // 获取视频上次学习进度
    getLearnDuration() {
      const { chapterId, openCourseId: userProductId } = this.$route.params;
      reqNewLearnProgress(userProductId).then((res) => {
        if (res) {
          const lastLearnDuration = res?.data?.find(
            (item) => Number(item.chapterId) === Number(chapterId),
          )?.position;
          this.lastLearnDuration = lastLearnDuration;
        }
      });
    },
    videoControl() {
      const controlTime = () => {
        this.controlShow = true;
        if (this.controlTimer) {
          clearTimeout(this.controlTimer);
        }
        this.controlTimer = setTimeout(() => {
          this.controlShow = false;
        }, 8000);
      };
      document.getElementsByClassName('video-control')[0].addEventListener(
        'click',
        () => {
          if (this.controlShow) return;
          controlTime();
        },
        false,
      );
      this.$nextTick(() => {
        // 刷新播放状态
        const myVideo = document.getElementById('playbackVideo');
        this.videoPlaying = !myVideo.paused;
        // 监听全屏
        myVideo.addEventListener('webkitendfullscreen', () => {
          this.videoPlaying = !myVideo.paused;
        });
      });
    },

    // 上报进度计时器，300秒上报一次
    setTimer() {
      window.clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.reportCount += 1;
        if (this.reportCount >= 300) {
          this.reportPlayerTime(0);
        }
      }, 1000);
    },

    // 回放播放
    onPlayerPlayLive() {
      // console.log('回放播放');
      this.reportCount = 0;
      if (!this.isFirstEnter) {
        this.setTimer(); // 开始计时上报
        return;
      }
      this.firstReportClock = setInterval(() => {
        try {
          // eslint-disable-next-line no-undef
          if ($.DW && $.DW.getPlayerTime && $.DW.getPlayerTime()) {
            clearInterval(this.firstReportClock);
            // 首次回放播从上次学习到的时间开始播放
            // eslint-disable-next-line no-undef
            const videoTotalTime = $.DW.getDuration();
            if (this.lastLearnDuration < videoTotalTime) {
              // eslint-disable-next-line
              this.lastLearnDuration && $.DW.seek(this.lastLearnDuration);
              const myVideo = document.getElementById('playbackVideo');
              this.videoPlaying = !myVideo.paused;
            }
            this.reportPlayerTime(1, true, this.lastLearnDuration);
            this.isFirstEnter = false;
            this.setTimer(); // 开始计时上报
          }
        } catch {
          // err
        }
      }, 1000);
    },

    // 回放暂停
    onPlayerPauseLive() {
      // console.log('回放暂停');
      window.clearInterval(this.timer);
      // 当前播放位置大于等于视频长度时，不进行播放暂停上报，进行播放结束上报
      // eslint-disable-next-line
      const currentTime = $.DW.getPlayerTime();
      // eslint-disable-next-line
      const videoTotalTime = $.DW.getDuration();
      if (currentTime < videoTotalTime) {
        this.reportPlayerTime(2); // 回放暂停上报
      }
    },
    // 回放结束
    onPlayerLiveEnded() {
      // console.log('结束～');
      window.clearInterval(this.timer);
      // clearInterval(this.sliderTimer);
      // this.currentDuration = this.totalDuration; // 解决回放结束 时间不相等的情况
      this.videoPlaying = false;
      this.reportPlayerTime(3); // 结束上报
    },
    // 回放
    setPlayerCallBackLive() {
      // eslint-disable-next-line
      if ($.DW) {
        this.onCCPlayerLoadedLive();
      } else {
        window.on_cc_live_player_load = this.onCCPlayerLoadedLive;
      }
      window.on_cc_live_player_load = this.on_cc_live_player_load; // 播放器加载完成
      window.on_spark_player_pause = this.onPlayerPauseLive; // 回放暂停
      window.on_player_start = this.onPlayerPlayLive; // 回放播放
      window.on_spark_player_end = this.onPlayerLiveEnded; // 停止
      window.on_cc_login_success = this.on_cc_login_success; // 登录成功
      window.on_cc_live_chat_msg = this.on_cc_live_chat_msg; // 所有的聊天记录
      window.on_cc_login_error = this.on_cc_login_error; // 登录失败的回调
    },
    // 回放初始化
    onCCPlayerLoadedLive() {
      window.ccH5PlayerLiveJsLoaded = true;
      this.createPlayerLive();
    },
    // 登录成功
    on_cc_login_success(data) {
      // 视频类型 1:大屏模式 ，2：问答、视频、聊天 ，3：视频、聊天，4：文档、视频。聊天，5：视频、文档、问答、聊天，6：视频、问答
      this.fileVideo = data.template.type === 4;
      // eslint-disable-next-line
      $.DW.isShowBar(1); // 隐藏控制条
    },
    // 登录失败的回调
    on_cc_login_error() {
      this.jurisdiction = true;
    },
    // eslint-disable-next-line
    on_cc_live_player_load() {
      // 播放器加载完成
      this.videoControl();
      if (this.firstload) return; // 第一次播放器加载完成执行
      this.firstload = setTimeout(() => {
        this.controlShow = false;
      }, 8000);
      this.getSliderValue();
    },
    getSliderValue() {
      // 进度条的计算
      clearInterval(this.sliderTimer);
      /* eslint-disable */
      const videoTotalTime = $.DW.getDuration(); // 获取视频总时长
      this.totalDuration = this.formatTime(videoTotalTime);
      this.sliderTimer = setInterval(() => {
        this.currentTimeStamp = $.DW.getPlayerTime(); // 获取当前播放时间
        this.sliderValue = (this.currentTimeStamp / videoTotalTime) * 100;
        this.currentDuration = this.formatTime(this.currentTimeStamp);
      }, 1000);
      /* eslint-enable */
    },
    formatTime(time) {
      const data = timerCount(time * 1000, 2);
      return `${data.h === '00' ? '' : `${data.h}:`}${data.m}:${data.s}`;
    },
    // 更改进度条
    onChange(sliderValue) {
      /* eslint-disable */
      const videoTotalTime = $.DW.getDuration(); // 获取视频总时长
      $.DW.seek((sliderValue / 100) * videoTotalTime);
      this.reportPlayerTime(4); //拖拽进度条上报
      /* eslint-enable */
    },
    on_cc_live_chat_msg(data) {
      // 所有的聊天信息
      this.chatList.push(data);
    },
    switchSpeed() {
      if (this.isFullScreen) {
        this.speedPopup = true;
      } else if (this.currentSpeedIndex + 1 < this.speed.length) {
        // eslint-disable-next-line
        this.currentSpeedIndex++;
      } else {
        this.currentSpeedIndex = 0;
      }
      // eslint-disable-next-line
      $.DW.playbackRate(this.speed[this.currentSpeedIndex]);
    },
    switchSpeedPopup(index) {
      this.currentSpeedIndex = index;
      this.speedPopup = false;
      // eslint-disable-next-line
      $.DW.playbackRate(this.speed[this.currentSpeedIndex]);
    },
    /**
     * 创建直播播放器
     */
    async createPlayerLive() {
      const res = await liveBroadcast(this.routeParams.resourceId);
      const { isCommentGroup = 0 } = res.data;
      this.isCommentGroup = isCommentGroup;
      this.loading = false;
      const { id: userId } = this.userInfo;
      /* eslint-disable */
      $.DW.config({
        userId: LIVE_SITE_ID,
        roomId: this.routeParams.vid,
        recordId: this.recordId,
        viewername: String(userId),
        viewertoken: `${userId}:${this.routeParams.openCourseId}`,
        isH5play: true,
        fastMode: true,
        groupId: this.buyInfo.skuId,
      });
      /* eslint-enable */
    },
    // 播放，暂停
    playPause() {
      const myVideo = document.getElementById('playbackVideo');
      if (myVideo.paused) {
        myVideo.play();
        this.videoPlaying = true;
      } else {
        myVideo.pause();
        this.videoPlaying = false;
      }
    },
    changeTab(index) {
      // 更改选项
      if (this.selected === index && index === 0) {
        this.showTabCard = !this.showTabCard;
        return;
      }
      this.selected = index;
      if (index > 0) {
        this.showTabCard = false;
      }
    },
    changeList(index) {
      this.cardSelected = index;
      this.showTabCard = false;
    },
    // 横竖屏切换
    fullScreenClick() {
      if (this.isFullScreen) {
        // 全屏
        this.isFullScreen = false;
        this.iconStatus = true;
        this.$nextTick(() => {
          const winW = window.innerWidth;
          const winH = window.innerHeight;
          const ele = document.getElementsByClassName('video-record-page')[0];
          ele.style.width = `${winW}px`;
          ele.style.height = `${winH}px`;
          ele.style.transform = 'rotate(0)';
          ele.style.transformOrigin = 'bottom left';
        });
      } else {
        // 非全屏
        this.isFullScreen = true;
        this.selected = 0;
        this.$nextTick(() => {
          const winH = window.innerHeight;
          const winW = window.innerWidth;
          const ele = document.getElementsByClassName('is-full-screen')[0];
          ele.style.width = `${winH}px`;
          ele.style.height = `${winW}px`;
          ele.style.transform = `rotate(90deg) translateX(-${winW}px)`;
          ele.style.transformOrigin = 'bottom left';
        });
      }
    },

    // 上报当前学习进度
    // 上报类型
    reportPlayerTime(isDrag = 0, isFirst = false, lastLearnProgress) {
      const { chapterId, resourceId, openCourseId } = this.routeParams;
      // console.log('要上报～');
      // 获取当前位置时间
      let currentTime;
      //  获取视频总时长
      let videoTotalTime;

      // eslint-disable-next-line
      currentTime = isFirst ? 0 : $.DW && $.DW.getPlayerTime();
      // eslint-disable-next-line
      videoTotalTime = $.DW && $.DW.getDuration();

      if (isFirst && lastLearnProgress && lastLearnProgress < videoTotalTime) {
        currentTime = lastLearnProgress;
      }
      if ((isFirst || currentTime) && videoTotalTime) {
        if (currentTime - videoTotalTime > 0) currentTime = videoTotalTime;
        const { id } = this.userInfo;
        const postData = {
          userId: id,
          productId: this.productId,
          productSkuId: this.buyInfo.skuId,
          userProductId: openCourseId,
          curriculumId: this.productCurriculumId,
          chapterId,
          chapterName: this.headerTitle,
          sourceType: 1, // 录播
          position: Math.ceil(currentTime),
          learnProgress: (Math.ceil(currentTime) / Math.ceil(videoTotalTime)).toFixed(2),
          reportTime: this.reportCount,
          isDrag,
          source: judgmentPlatform() === 'HarmonyOS' ? 8 : 5, // 5:h5 8:鸿蒙
          ua: window.navigator.userAgent,
          updateTime: this.$root.getLocalTime(),
        };

        this.reportCount = 0;
        postData.liveId = resourceId;
        postData.videoId = this.recordVideoId;

        sendUploadStudyProgress(postData)
          .then(() => {
            console.log('上报成功～playback');
          })
          .catch(() => {
            console.log('上报参数出错了');
          });
      }
    },

    // 销毁播放器
    destroyPlay() {
      window.clearInterval(this.timer);
      clearInterval(this.sliderTimer);
      clearInterval(this.firstReportClock);
      this.timer = null;
      window.ccH5PlayerLiveJsLoaded = false;
      // TODO: 回放SDK提供的destroy()方法报错，导致无法进行切换，手动destroy
      const video = document.getElementById('playbackVideo');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }

      // eslint-disable-next-line
      // $.DW && $.DW.destroy && $.DW.destroy();
    },
    touchstartHandle(refName, e) {
      if (this.fullscreenVal || !this.fileVideo) return;
      const element = e.targetTouches[0];
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY,
      };
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft;
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop;
    },
    touchmoveHandle(refName, e) {
      if (this.fullscreenVal) return;
      const element = e.targetTouches[0];
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x = this.coordinate.elePosition.left + (element.clientX - this.coordinate.client.x);
      let y = this.coordinate.elePosition.top + (element.clientY - this.coordinate.client.y);
      // 限制可移动距离，不超出可视区域
      /* eslint-disable */

      x =
        x <= 0
          ? 0
          : x >= innerWidth - this.$refs[refName].offsetWidth
            ? innerWidth - this.$refs[refName].offsetWidth
            : x;
      y =
        y <= 0
          ? 0
          : y >= innerHeight - this.$refs[refName].offsetHeight
            ? innerHeight - this.$refs[refName].offsetHeight
            : y;
      /* eslint-enable */
      // 移动当前元素
      this.$refs[refName].style.left = `${x}px`;
      this.$refs[refName].style.top = `${y}px`;
      // this.$refs[refName].style.bottom = 'auto'
      // this.$refs[refName].style.right = 'auto'

      e.preventDefault(); // 阻止屏幕滚动的默认行为
    },
    /*gio埋点 */
    async gioReName() {
      let { data } = await reqClassNameType(this.productId);
      gio('track', 'listenCourse_event', {
        videoID_var: this.routeParams.vid,
        videoName_var: this.headerTitle,
        videoType_var: '直播回放',
        isAudition_var: '是',
        courseId_var: this.productId.toString(),
        courseName_var: this.productName,
        classSize_var: data.className,
        platform_var: gioPlatform(),
        enter_var: '导学页',
      });
    },
    evaluateClose() {
      this.evaluateVisible = false;
    },
  },
  async beforeRouteLeave(to, from, next) {
    try {
      this.reportPlayerTime(2);
      // eslint-disable-next-line
      // $.DW && $.DW.destroy && $.DW.destroy();
      this.destroyPlay();
    } catch {
      // err
    }
    next();
  },
};
</script>
<style scoped lang="scss">
.playBack {
  .video-record-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;

    .video-record {
      display: flex;
      align-items: center;
      width: 100%;
      height: calc(100vw * (9 / 16));
      background: black;

      #playbackPlayer {
        width: 100%;
        height: 100%;
      }

      .jurisdiction {
        position: absolute;
        top: 15%;
        left: 50%;
        z-index: 1111111111111;
        color: #000;
        font-size: 26px;
        transform: translate(-50%, -50%);
      }

      .video-control {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: calc(100vw * (9 / 16));
        color: white;

        .control-top {
          display: flex;
          align-items: center;
          height: 20%;
          background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));

          .live-title {
            width: 75%;
            margin-left: 20px;
            padding: 10px 0;
            overflow: hidden;
            color: white;
            font-weight: 600;
            font-size: 30px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .control-icon {
            margin-right: 0;
          }
          .zan {
            width: 43px;
            height: 43px;
          }
        }

        .control-bottom {
          z-index: 1;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-end;
          height: 30%;
          padding-top: 20px;
          background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));

          .slider {
            width: 100%;
            margin-bottom: 20px;
            padding: 0 40px;
          }

          .control-bottom-bottom {
            display: flex;
            width: 100%;

            .control-bottom-left {
              display: flex;
              align-items: center;
              font-size: 16px;

              div {
                font-size: 28px;
              }
            }

            .control-bottom-right {
              display: flex;
              align-items: center;
              margin-left: auto;

              span {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                margin: 0 15px;
                font-size: 30px;
              }

              img {
                width: 60px;
                height: 60px;
                margin: 0 15px;
              }
            }
          }
        }
      }

      .control-icon {
        width: 60px;
        height: 60px;
        margin: 15px;
      }
    }

    .file-video-record {
      #playbackPanel {
        width: 100%;
        height: 100%;
        background: #fff;
      }

      #playbackPlayer {
        position: fixed;
        top: calc(100vw * 0.94);
        right: 0;
        z-index: 10;
        width: 200px;
        height: 160px;
        overflow: hidden;
        background: #ccc;
      }
    }

    .live-content {
      position: relative;
      width: 100%;
      // flex: 1;
      height: calc(100vh - (100vw * (9 / 16)));
      overflow: auto;

      // background: red;
      .live-content-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;

        .live-content-tab {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 120px;
          background: #fff;

          li {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50%;
            color: #ff6c02;
            font-size: 32px;
            text-align: center;

            img {
              width: 40px;
              height: 40px;
              margin-left: 10px;
            }

            .border {
              position: absolute;
              right: 0;
              bottom: -10px;
              left: 0;
              display: block;
              width: 50px;
              height: 6px;
              margin: 0 auto;
              background: #ff6c02;
              border-radius: 10px 10px 0 0;
            }
          }
        }

        .tab-card {
          position: absolute;
          top: 100px;
          left: 0;
          z-index: 200;
          width: 100%;
          height: 208px;
          background: #fff8f2;

          li {
            padding: 40px 0 0 100px;
            color: #333;
            font-size: 28px;

            .icon {
              position: relative;
              top: 6px;
              width: 32px;
              height: 32px;
            }
          }

          li.active {
            color: #ff6c02;
            font-size: 28px;
          }
        }

        .tab-content {
          flex: 1;
          width: 100%;
          overflow: auto;
        }

        .tab-content-padding {
          padding-top: 160px;
        }
      }
    }
  }

  .is-full-screen {
    .video-record {
      width: 100%;
      height: 100%;

      #playbackPlayer {
        width: 75%;
      }

      .fullPlaybackPlayer {
        width: 100% !important;
      }

      .video-control {
        width: 100%;
        height: 100%;
      }
    }

    .file-video-record {
      #playbackPanel {
        width: 75%;
      }

      #playbackPlayer {
        position: absolute;
        top: 0 !important;
        right: 0 !important;
        left: initial !important;
        width: 25%;
        height: calc(100vw * 0.27);
      }

      .fullPlaybackPanel {
        width: 100% !important;
      }
    }

    .live-content {
      position: absolute;
      top: 0;
      right: 0;
      width: 25%;
      // height: calc(100vw * 0.73);
      height: 100%;
      overflow: hidden;
      background: #fafafa;

      .teacherList {
        width: 100%;
        height: 10%;
        padding: 25px 30px 0;
        overflow: hidden;
        font-size: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: #fff;
      }

      .live-content-box {
        position: relative;

        .tab-card {
          top: 100px;
          height: 150px;

          li {
            padding: 20px;
          }
        }
      }
    }

    .android-live-content {
      position: fixed;

      .live-content-box {
        .tab-card {
          position: fixed;
          top: 22%;
          right: 0;
          left: initial;
          width: 25%;
        }
      }
    }

    .file-live-content {
      top: calc(100vw * 0.27);
      height: calc(100vw * 0.73);

      .live-content-box {
        .tab-card {
          top: 100px;
        }
      }
    }

    // 安卓机 三分屏回放
    .android-live-content.file-live-content {
      .live-content-box {
        .tab-card {
          top: 40%;
        }
      }
    }

    .speedPopup {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 11;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);

      div {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        flex-wrap: wrap;
        width: 30%;
        height: 100%;
        padding: 80px 0;
        background: rgba(0, 0, 0, 0.3);

        p {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          color: #fff;
          font-size: 30px;
        }

        .active {
          color: #ff6c02;
        }
      }
    }

    .fullRecoment {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 111;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);

      .recomentContent {
        position: absolute;
        top: 0;
        right: 0;
        width: 50%;
        height: 100%;
        overflow: auto;
        background: rgba(0, 0, 0, 0.3);

        .title {
          margin-top: 40px;
          padding-left: 40px;
          color: #fff;
          font-size: 40px;
        }
      }
    }
  }

  .fullSlider {
    position: absolute;
    top: 50%;
    left: 14%;
    width: 5px;
    height: 90%;
    transform: translateY(-50%);
  }
}
</style>
